import { useContext, useEffect, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { PortalContext } from "_+_Portal/context/Provider";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { wsGetDemora } from "_+_Portal/_-_Autocheckin/context/action/demora";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BtnAnunciarme,
  BtnRecepcionados,
  DemoraBox,
  DemoraPacienteBody,
  DemoraPacienteBotones,
  DemoraPacienteContainer,
  DemoraPacienteListaContainer,
  DemoraPacienteListaElemento,
} from "./localStyle";
import camelize from "global/utils/camelize";
import { GlobalContext } from "global/context/Provider";
import { convertHora } from "global/utils/convertHora";
import AyudaPreguntaIcon from "_+_Portal/assets/images/generico/AyudaPreguntaIcon";
import { wsGetTurnosPacienteDelDia } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import CardAguardar from "_+_Portal/_-_Autocheckin/components/genericos/CardAguardar/CardAguardar";

const DemoraPaciente = ({ setError, turnoActual }) => {
  // -------------------------  useContex  ----------------------------
  const {
    turnosAutoCheckInState,
    turnosAutoCheckInDispatch,
    pasoDispatch,
    turnosSeleccionadosState,
    demoraDispatch,
    demoraState,
  } = useContext(AutocheckContext);
  const { selectDropDownState } = useContext(PortalContext);
  const { authState } = useContext(GlobalContext);

  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  const [showLista, setShowLista] = useState(false);
  const [turno, setTurno] = useState(null);
  const [listaTurnos, setListaTurnos] = useState(null);
  // const loading = turnosAutoCheckInState.turnosAutoCheckIn.loading;

  const idPacFamiliar = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.codigo
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
        ?.codigo
    : false;

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];

  const pacienteNombre = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.nombre
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
        ?.nombre
    : authState?.auth?.data?.paciente?.nombre ?? "";

  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [loading, setLoading] = useState(true);
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------

  const volver = () => {
    setPaso("TurnosRecepionados")(pasoDispatch);
  };
  const mostrarListaPacientes = () => {
    setShowLista(true);
  };
  const verTurnosRecepcionados = () => {
    setPaso("TurnosRecepionados")(pasoDispatch);
  };

  const irAFilaVirtual = (isCorrect, demora) => {
    setLoading(false);
  };

  const refrescarTurnos = (isCorrect, data) => {
    if (isCorrect && data) {
      // lista Presentes
      let presentes = data.filter((e) => e.presente);
      setListaTurnos(presentes);

      let turnoActualData = presentes.filter(
        (t) => t.idturno === listTurnosSeleccionado[turnoActual]?.idturno
      )[0];

      if (!turnoActualData) return;

      setTurno(turnoActualData);
      wsGetDemora(
        turnoActualData.idEspecialidad,
        turnoActualData.idMedico,
        turnoActualData.idturno,
        true,
        (isCorrect, demora) => irAFilaVirtual(isCorrect, demora)
      )(demoraDispatch);
    } else {
      setLoading(false);
    }
  };
  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  useEffect(() => {
    setLoading(true);
    wsGetTurnosPacienteDelDia(idPacFamiliar, refrescarTurnos)(turnosAutoCheckInDispatch);
  }, []);
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"AUTO CHECK IN"}
        type={"no-circle"}
      >
        {!loading && (
          <DemoraPacienteContainer>
            <CardBlueHeart
              medico={turno?.medico ? turno?.medico : turno?.especialidad}
              turnoTitle={turno?.especialidad}
              pasoActual={turnoActual + 1}
              pasoTotal={listaTurnos?.length}
            />
            <DemoraPacienteBody showLista={showLista}>
              <CardAguardar
                horaTurno={turno?.hora}
                nombreTurno={turno?.especialidad}
                sedeTurno={turno?.centro}
                flgSoloConsulta={false}
                medico={turno?.medico}
                consultorioTurno={
                  !turno?.consultorio ? "" : turno?.consultorio
                }
                btnDisable={true}
                handleClick={() => {}}
                filaVirtual={true}
              />
              <DemoraPacienteBotones>
                <BtnRecepcionados
                  className="bgc-latex30 rb18b c-white pointer"
                  onClick={verTurnosRecepcionados}
                >
                  Ver turnos recepcionados
                </BtnRecepcionados>
              </DemoraPacienteBotones>
              {demoraState.demora.data?.demora >= 0 && (
                <>
                  {demoraState.demora.data?.demora === 0 ? (
                    ""
                  ) : (
                    <DemoraBox>
                      <span className="rb18l c-latex10">
                        La demora hasta la atención es de:
                      </span>
                      <span className="c-primary rb70b">
                        {demoraState.demora.data?.demora}
                      </span>
                      <span className="rb18b c-latex10">
                        Minutos (aproximadamente)
                      </span>
                    </DemoraBox>
                  )}
                  {!showLista ? (
                    <>
                      {/* <span className="demopraPaciente-text-center rb18b c-broccoli">
                        Vemos que ya se anunció. Le pedimos que aguarde a ser
                        llamado
                      </span> */}
                      <span
                        className="rb18b c-latex10 demopraPaciente-underline"
                        onClick={mostrarListaPacientes}
                      >
                        Ver listado de pacientes en espera
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="demora-tituloListaPacientes c-latex10 rb18b">
                        Listado de pacientes
                        <AyudaPreguntaIcon color={"black"} />
                      </span>
                      <DemoraPacienteListaContainer>
                        {Array.isArray(
                          demoraState.demora.data?.listPacienteEnEspera
                        ) &&
                          demoraState.demora.data?.listPacienteEnEspera.map(
                            (item, index) => (
                              <DemoraPacienteListaElemento key={index}>
                                <span className={`rb18b`}>
                                  {convertHora(item.hora)}
                                </span>
                                <span className={`rb18b`}>
                                  Paciente {item.paciente}
                                </span>
                                <span
                                  className={`${
                                    item.estado === "ANUNCIADO" && "c-broccoli"
                                  } rb18b`}
                                >
                                  {camelize(item.estado)}
                                </span>
                              </DemoraPacienteListaElemento>
                            )
                          )}
                        <DemoraPacienteListaElemento
                          colorEstado={true}
                          turnoPaciente={true}
                        >
                          <span className={`rb18b`}>{turno?.hora}</span>
                          <span className={`rb18b`}>
                            {camelize(pacienteNombre)}
                          </span>
                        </DemoraPacienteListaElemento>
                      </DemoraPacienteListaContainer>
                    </>
                  )}
                </>
              )}
              <BtnAnunciarme
                className="bgc-primary rb18b c-white pointer"
                onClick={verTurnosRecepcionados}
              >
                Anunciarme
              </BtnAnunciarme>
            </DemoraPacienteBody>
          </DemoraPacienteContainer>
        )}
      </LayoutPasos>
    </>
  );
};
export default DemoraPaciente;
